import { render, staticRenderFns } from "./wxBind.vue?vue&type=template&id=2410e160"
import script from "./wxBind.vue?vue&type=script&lang=js"
export * from "./wxBind.vue?vue&type=script&lang=js"
import style0 from "./wxBind.vue?vue&type=style&index=0&id=2410e160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports